import React from "react";
import "./Skills.css";
import { FaReact, FaNodeJs, FaHtml5, FaCss3Alt, FaDatabase, FaPython, FaJava, FaRobot } from "react-icons/fa";
import { SiJavascript, SiMongodb } from "react-icons/si";

const skills = [
  { name: "HTML5", icon: <FaHtml5 />, color: "#e34c26" },
  { name: "CSS", icon: <FaCss3Alt />, color: "#264de4" },
  { name: "JavaScript", icon: <SiJavascript />, color: "#f0db4f" },
  { name: "React.js", icon: <FaReact />, color: "#61dbfb" },
  { name: "Java", icon: <FaJava />, color: "#68a063" },
  { name: "Machine learning alogorithms", icon: <FaRobot />, color: "#4db33d" },
  { name: "MySQL", icon: <FaDatabase />, color: "#00758f" },
  { name: "Python", icon: <FaPython />, color: "#3776ab" },
];

function Skills() {
  return (
    <section id="skills" className="skills-section">
      <h2>Technical Skills</h2>
      <div className="skills-grid">
        {skills.map((skill, index) => (
          <div
            className="skill-card"
            key={index}
            style={{ borderColor: skill.color }}
          >
            <div className="icon" style={{ color: skill.color }}>
              {skill.icon}
            </div>
            <h4>{skill.name}</h4>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
